import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ElementsService, MasterViewModel } from "src/proxy";

@Injectable()
export class NodeLevelStoreService {

    _nodeLevel$ = new BehaviorSubject<MasterViewModel[]>(null);

    constructor(private elementService: ElementsService) {
    }

    loadNodeLevels() {
        return this.elementService.getAllNodeLevels();
    }

    get nodeLevel() {
        return this._nodeLevel$.value;
    }

    set nodeLevel(data: MasterViewModel[]) {
        this._nodeLevel$.next(data);
    }

    get nodeLevel$() {
        return this._nodeLevel$;
    }
}